import { Component, OnInit } from '@angular/core';
import {environment} from "../../environments/environment";
import { ConfigurationService } from "../core/services/configuration.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  version: string

  constructor(private configService: ConfigurationService) { }

  ngOnInit(): void {
    this.version = this.configService.config.version
  }

}
